var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "main-orderlist", "data-disabled": _vm.disabled } },
    [
      _c(
        "ul",
        { ref: "wrapperItems", staticClass: "wrapper-items" },
        _vm._l(_vm.orders, function(order, index) {
          return order.table_number == _vm.table_number
            ? _c(
                "li",
                { key: index, staticClass: "item" },
                [
                  _c("div", { staticClass: "outer-detail row" }, [
                    _c("div", { staticClass: "col-8 name" }, [
                      _vm._v(
                        "\n          " + _vm._s(order.item) + "\n          "
                      ),
                      _c(
                        "span",
                        { staticClass: "outer-qty" },
                        [
                          _c("span", { staticClass: "n" }, [
                            _vm._v("x" + _vm._s(order.quantity))
                          ]),
                          _vm._v(" "),
                          order.uuid === _vm.currentUuid
                            ? _vm._l(_vm.plusoneCount, function(i) {
                                return _c(
                                  "span",
                                  {
                                    key: i,
                                    staticClass:
                                      "plusone fadeOutUp animated text-success"
                                  },
                                  [
                                    _vm._v(
                                      "\n                +1\n              "
                                    )
                                  ]
                                )
                              })
                            : _vm._e()
                        ],
                        2
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-4 price" }, [
                      _vm._v(
                        _vm._s(_vm.getNumber(_vm.getTotal([order]).preTax))
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  order.lots
                    ? _vm._l(order.lots, function(lot, lotIndex) {
                        return _c(
                          "div",
                          {
                            key: lotIndex,
                            staticClass: "col-12 no-padding mt-2"
                          },
                          [
                            _c("div", { staticClass: "outer-modifier row" }, [
                              _c("div", { staticClass: "col-8 name" }, [
                                _c("strong", [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(lot.lotCode) +
                                      "\n                "
                                  ),
                                  _c("i", {
                                    staticClass: "fas fa-pallet",
                                    staticStyle: { "font-size": "12px" }
                                  })
                                ])
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "col-4 price" }, [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(lot.unit) +
                                    "\n            "
                                )
                              ])
                            ])
                          ]
                        )
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  order.serials
                    ? _vm._l(order.serials, function(serial, serialIndex) {
                        return _c(
                          "div",
                          {
                            key: serialIndex,
                            staticClass: "col-12 no-padding mt-2"
                          },
                          [
                            _c("div", { staticClass: "outer-modifier row" }, [
                              _c("div", { staticClass: "col-8 name" }, [
                                _c("strong", [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(serial.serCode) +
                                      "\n                "
                                  ),
                                  _c("i", {
                                    staticClass: "fas fa-sd-card",
                                    staticStyle: { "font-size": "12px" }
                                  })
                                ])
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "col-4 price" }, [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(serial.unit) +
                                    "\n            "
                                )
                              ])
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "outer-modifier row",
                                staticStyle: { "font-size": "11px" }
                              },
                              [
                                _c("div", { staticClass: "col-8 name" }, [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(serial.serialNumber) +
                                      "\n            "
                                  )
                                ])
                              ]
                            )
                          ]
                        )
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm._l(order.modifiers, function(modifier, index_) {
                    return _c(
                      "div",
                      { key: index_, staticClass: "col-12 no-padding mt-1" },
                      [
                        _c("div", { staticClass: "outer-modifier row" }, [
                          _c("div", { staticClass: "col-8 name" }, [
                            _c("strong", [
                              _vm._v(_vm._s(modifier.modifier_name))
                            ])
                          ])
                        ]),
                        _vm._v(" "),
                        _vm._l(modifier.options, function(option, index__) {
                          return _c(
                            "div",
                            { key: index__, staticClass: "outer-modifier row" },
                            [
                              _c("div", { staticClass: "col-8 name" }, [
                                _vm._v(_vm._s(option.option))
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "col-4 price" }, [
                                _vm._v(_vm._s(_vm.getNumber(option.price)))
                              ])
                            ]
                          )
                        })
                      ],
                      2
                    )
                  }),
                  _vm._v(" "),
                  order.note
                    ? _c("div", { staticClass: "col-12 no-padding mt-1" }, [
                        _c("div", { staticClass: "outer-modifier row" }, [
                          _c("div", { staticClass: "col-8 name" }, [
                            _c("span", [_vm._v(_vm._s(order.note))])
                          ])
                        ])
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  order.discounts.length > 0
                    ? _c(
                        "div",
                        { staticClass: "outer-discount row mt-1" },
                        _vm._l(order.discounts, function(item, index) {
                          return item && item.value_type !== null
                            ? _c(
                                "div",
                                {
                                  key: index,
                                  staticClass: "col-12 text-right"
                                },
                                [
                                  _c("i", { staticClass: "fas fa-tag" }),
                                  _vm._v(" "),
                                  item.value_type == "percentage"
                                    ? _c("span", [
                                        _vm._v(
                                          _vm._s(item.discount_name) +
                                            " " +
                                            _vm._s(item.value_amount) +
                                            "%"
                                        )
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  item.value_type == "number"
                                    ? _c("span", [
                                        _vm._v(
                                          _vm._s(item.discount_name) +
                                            " " +
                                            _vm._s(_vm.currency) +
                                            " " +
                                            _vm._s(
                                              _vm.getNumber(item.value_amount)
                                            )
                                        )
                                      ])
                                    : _vm._e()
                                ]
                              )
                            : _vm._e()
                        }),
                        0
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c("div", { staticClass: "outer-action" }, [
                    _c(
                      "button",
                      {
                        staticClass: "btn-edit",
                        on: {
                          click: function($event) {
                            return _vm.handleClickEdit(order)
                          }
                        }
                      },
                      [_c("i", { staticClass: "fas fa-pencil-alt" })]
                    ),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "btn-delete",
                        on: {
                          click: function($event) {
                            return _vm.handleClickDelete(order)
                          }
                        }
                      },
                      [_c("i", { staticClass: "far fa-trash-alt" })]
                    )
                  ])
                ],
                2
              )
            : _vm._e()
        }),
        0
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-d0836576", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d0836576","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/apps/pos/sale/mobile/common/OrderList.vue
// module id = null
// module chunks = 